import { Service } from "./restService";

class AssetService extends Service {

    addAsset = (data) => {

        const url = 'asset';
        const body = '{"name":"' + data.name
            + '", "type":"' + data.type + '"}';

        return this.POST(url, body)
            .then(response => response);
    };

    addServerAttributes = (data, assetId) => {

        const url = 'plugins/telemetry/ASSET/' + assetId + '/SERVER_SCOPE';
        const body = JSON.stringify(data);

        return this.POST(url, body)
            .then(response => response);
    };

    addAssetEntity = (data, assetId) => {

        const url = 'entityView';
        const body = '{"keys":{"timeseries":[],' +
            '"attributes":{"ss":["coordinates", "latitude", "longitude"],"cs":[],"sh":[]}},' +
            '"endTimeMs":0,"startTimeMs":0,' +
            '"name":"' + data.name + '",' +
            '"type":"' + data.type + '",' +
            '"entityId":{"entityType":"ASSET",' +
            '"id":"' + assetId + '"}}';

        return this.POST(url, body)
            .then(response => response);
    };

    getAssetById = (assetId) => {
        const url = 'asset/' + assetId;
        return this.GET(url)
            .then(response => response);
    };

    getAssetAttributesById = (assetId) => {
        const url = 'plugins/telemetry/ASSET/' + assetId + '/values/attributes/SERVER_SCOPE';
        return this.GET(url)
            .then(response => response);
    };

    getAssets = () => {
        const url = 'tenant/assets?pageSize=100&page=0&textSearch=';
        return this.GET(url)
            .then(response => response);
    }
}

export default AssetService;
export {
    AssetService
}